const Terms = () => {
	return (
		<>
			<h1 className="display-3 mb-4">Terms of use</h1>
			<p></p>
			
		</>
	)
}
export default Terms